import { ErrorMap } from '@eroman/common/src/_base/validation/ErrorMap';

export class LoginVM {
    email = '';
    password = '';
    isLoading = false;
    errors: ErrorMap = {};
}
